import { Typeahead } from "react-bootstrap-typeahead";
import { Card, CardBody, Col, Form } from 'reactstrap';
import { multipleSelectionSubTitle } from '../../../../../Data/Forms/FormWidgetsData';
import { multipleWithHeadersData } from '../../../../../Data/Forms/FormWidgetsData/TypeaheadData';
import CommonCardHeader from '../../../../../Utils/CommonComponents/CommonCardHeader';
import { MultipleSectionsHeadersTitle } from '../../../../../Utils/Constants';

export default function MultipleSectionsWithHeaders() {

    return (
        <Col sm={12} md={6}>
            <Card>
                <CommonCardHeader title={MultipleSectionsHeadersTitle} subTitle={multipleSelectionSubTitle} />
                <CardBody>
                    <div id="multiple-datasets">
                        <Form className="theme-form">
                            <div>
                                <Typeahead id="multiple-typeahead" labelKey={"name"} multiple options={multipleWithHeadersData} placeholder="Choose a state..." className="shadow-none" />
                            </div>
                        </Form>
                    </div>
                </CardBody>
            </Card>
        </Col>
    )
}
